module.exports = __webpack_public_path__ + "static/img/album4_202501_02.14be672.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album4_202501_02.jpg
// module id = Fdaj
// module chunks = 98